const COLORS = [
    'rgba(255, 210, 162, 0.2)',
    'rgba(252, 160, 191, 0.2)',
    'rgba(248, 113, 219, 0.2)',
    'rgba(142, 45, 241, 0.2)',
    'rgba(86, 41, 234, 0.2)'
];

export default COLORS;
